"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigIntJson = void 0;
const axios_1 = __importDefault(require("axios"));
const parse_js_1 = __importDefault(require("../json/parse.js"));
const stringify_js_1 = __importDefault(require("../json/stringify.js"));
const { defaults } = axios_1.default;
exports.bigIntJson = async function bigIntJson(ctx, next) {
    // eslint-disable-next-line no-shadow
    const { request } = ctx;
    try {
        if ((request.bigIntJson || request.bigIntjson) && BigInt) {
            const originResponseType = request.responseType;
            const parser = parse_js_1.default({ storeAsString: true });
            const stringifier = stringify_js_1.default();
            const transformRequestWithBigIntJSON = (data, headers) => {
                if (Object.prototype.toString.call(data) === '[object Object]') {
                    if (headers && !headers['Content-Type']) {
                        headers['Content-Type'] = 'application/json;charset=utf-8';
                    }
                    return stringifier(data);
                }
                return data;
            };
            const transformResponseWithBigIntJSON = data => {
                /* eslint no-param-reassign:0 */
                if (typeof data === 'string' && originResponseType === 'json') {
                    try {
                        data = parser(data);
                    }
                    catch (e) {
                        /* Ignore */
                    }
                }
                return data;
            };
            // eslint-disable-next-line no-nested-ternary
            const originTransformRequest = Array.isArray(request.transformRequest) ?
                request.transformRequest :
                request.transformRequest ?
                    [request.transformRequest] :
                    [];
            // eslint-disable-next-line no-nested-ternary
            const originTransformResponse = Array.isArray(request.transformResponse) ?
                request.transformResponse :
                request.transformResponse ?
                    [request.transformResponse] :
                    [];
            request.transformRequest = [...originTransformRequest, transformRequestWithBigIntJSON];
            // 保持默认行为
            if (originTransformRequest.length === 0) {
                request.transformRequest.push(...defaults.transformRequest);
            }
            // axios默认的transformResponse仅做json解析，不再添加了
            request.transformResponse = [...originTransformResponse, transformResponseWithBigIntJSON];
            // 使用纯文本，禁用原生xhr的默认json解析
            if (request.responseType === 'json') {
                request.responseType = 'text';
            }
        }
    }
    catch (error) {
        ctx.error = error;
    }
    await next();
};
exports.bigIntJson.id = 'bigIntJson';
//# sourceMappingURL=bigIntJson.js.map